<template>
  <main></main>
</template>

<script>
import { createNamespacedHelpers, mapState, mapActions, mapMutations, mapGetters } from 'vuex';

const application = createNamespacedHelpers('application');

export default {
  mounted() {
    this.$nextTick(() => {
      if (this.isLiteVersion) {
        this.setKwtMode('previewLite');
      } else {
        this.setKwtMode('preview');
      }
      if (this.activityId) {
        this.launchByActivityId(this.activityId);
      } else if (this.activityPreviewId) {
        this.launchByActivityPreviewId(this.activityPreviewId);
      } else if (this.activityType) {
        this.launchByActivityType(this.activityType);
      } else if (this.teacherCreationPreviewId) {
        this.launchByTeacherCreationPreviewId(this.teacherCreationPreviewId);
      }
    });
  },

  data() {
    return {};
  },

  computed: {
    ...mapState('activity', {
      activityData: 'data'
    }),
    ...mapState('application', {
      isLiteVersion: state => state.isLiteVersion
    }),
    ...mapGetters('activity', ['isSpotCheckActivity']),

    activityId() {
      return this.$route.query.activityId;
    },
    activityPreviewId() {
      return this.$route.query.activityPreviewId;
    },
    teacherCreationPreviewId() {
      return this.$route.query.teacherCustomCreationId;
    },
    activityType() {
      return this.$route.query.type;
    }
  },

  methods: {
    ...mapActions('activity', [
      'fetchActivityData',
      'fetchActivityPreviewData',
      'fetchRandomDataForActivityTypeVariant'
    ]),
    ...mapMutations('activity', ['setSpotCheckRetries']),
    ...application.mapMutations(['setKwtMode']),

    async launchByActivityType(activityType) {
      // CSC - Probably broken...
      await this.fetchRandomDataForActivityTypeVariant(activityType);
      this.checkIfSpotCheck();
      this.$router.replace({ path: `/activities/${this.activityData.type}` });
    },

    async launchByActivityId(activityId) {
      await this.fetchActivityData({ activityId });
      this.checkIfSpotCheck();
      this.$router.replace({
        path: `/activities/${this.activityData.activityTypeVariant.variant}`
      });
    },

    async launchByActivityPreviewId(activityPreviewId) {
      await this.fetchActivityPreviewData({ activityPreviewId });
      // this.checkIfSpotCheck();
      this.$router.replace({
        path: `/activities/${this.activityData.activityTypeVariant.variant}`
      });
    },

    async launchByTeacherCreationPreviewId(teacherCreationPreviewId) {
      await this.fetchActivityPreviewData({ teacherCreationPreviewId });
      this.$router.replace({
        path: `/activities/${this.activityData.activityTypeVariant.variant}`
      });
    },

    checkIfSpotCheck() {
      if (this.isSpotCheckActivity) {
        this.setSpotCheckRetries(999);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: 'hwtfutura-semibold';
  font-size: 15px;
  padding: 0;
  margin: 10px 0 0 0;
  text-transform: uppercase;
  & em {
    text-transform: none;
  }
}
.enter-nid {
  text-align: center;
  padding: 10px 0 0 0;
  p {
    font-family: 'hwtfutura-bold';
    display: inline-block;
    color: black;
  }
}
.nid {
  font-family: 'hwtfutura-bold';
  text-align: center;
  font-size: 18px;
  width: 100px;
  display: inline-block;
  border: 2px solid black;
  border-radius: 5px;
  height: 30px;
  padding: 0;
  line-height: 30px;
}
.nid-go {
  display: inline-block;
  border: none;
  font-size: 18px;
  font-family: 'hwtfutura-bold';
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  background-color: black;
  color: white;
}
.activity-listings {
  margin: 15px auto 0 auto;
  width: 980px;
  // height: 700px;
  // overflow-y: scroll;
  ul {
    list-style: none;
    margin: 0;
    padding: 8px 0 12px;
    text-align: center;
    border-top: 1px solid #ccc;
    li {
      display: inline-block;
      margin: 2px;
      padding: 0;
      vertical-align: top;
      button {
        font-family: 'hwtprint-bold';
        border: none;
        height: 50px;
        vertical-align: top;
        padding: 0px 10px;
        font-size: 15px;
        border-radius: 5px;
        background-color: #95c88a;
        &.qa {
          background-color: #ff8a00;
        }
        &.qa:hover {
          background-color: #ff9c00;
        }
        &.dev {
          background-color: #ff0066;
        }
        &.dev:hover {
          background-color: #ff0000;
        }
        &:hover {
          background-color: #8de279;
        }
        &.disabled {
          opacity: 0.65;
          cursor: not-allowed;
          background-color: #ccc;
        }
        span {
          display: block;
          font-size: 12px;
          line-height: 10px;
          font-family: 'hwtfutura';
        }
      }
      &.newJson button {
        background: #f1da36; /* Old browsers */
        background: linear-gradient(to bottom, #f1da36 0%, #fefcea 120%);
      }
    }
  }
}
</style>
